export default __webpack_public_path__ + "static/media/bitcoin.229e5f10.svg";